//
//
//
//
//
//
//
//
var script = {
  props: ['node', 'updateAttrs', 'view'],
  computed: {
    color() {
      return this.node && this.node.attrs.color;
    },

    text() {
      return this.node && this.node.attrs.text;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/renderers/Lozenge.vue_rollup-plugin-vue=script.js